import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const nonNegativeWholeNumberValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (value === null || value === undefined || value === '') {
            return null;
        }

        const s = String(value);
        return /^(0|[1-9]\d*)$/.test(s) ? null : { nonNegativeWholeNumber: true };
    };
};

export const integerValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (value === null || value === undefined || value === '') {
            return null;
        }

        const s = String(value);
        return /^(0|-?[1-9]\d*)$/.test(s) ? null : { integer: true };
    };
};

export const numberValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (value === null || value === undefined || value === '') {
            return null;
        }

        const s = String(value);
        return /^[-+]?(?:0|[1-9]\d*)(?:\.\d+)?$/.test(s) ? null : { number: true };
    };
};

export const postcodeValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (value === null || value === undefined || value === '') {
            return null;
        }

        const s = String(value);
        return /^\d{4}$/.test(s) ? null : { postcode: true };
    };
};
